export enum DistanceAccuracy {
    Unknown = 0,
    ZipToZipCrowFlies = 1,
    ZipToZipDrivingDirections = 2,
    ZipToAddressCrowFlies = 3,
    ZipToAddressDrivingDirections = 4,
    AddressToAddressCrowFlies = 5,
    AddressToAddressDrivingDirections = 6,
}

const distanceAccuracyDescription = {
    Unknown: 'Unknown',
    ZipToZipCrowFlies: 'Zip To Zip Crow Flies',
    ZipToZipDrivingDirections: 'Zip To Zip Driving Directions',
    ZipToAddressCrowFlies: 'Zip To Address Crow Flies',
    ZipToAddressDrivingDirections: 'Zip To Address Driving Directions',
    AddressToAddressCrowFlies: 'Address To Address Crow Flies',
    AddressToAddressDrivingDirections: 'Address To Address Driving Directions',
};

export const DistanceAccuracyDescription = {
    ...distanceAccuracyDescription,

    get: (value: DistanceAccuracy | undefined | null): string | undefined => {
        if (typeof (value) === "string") {
            return distanceAccuracyDescription[value];
        }
        if (value===null || value===undefined) {
            return undefined;
        }
        return distanceAccuracyDescription[DistanceAccuracy[value]  as keyof typeof distanceAccuracyDescription];
    },
    all: [
        { value: 0, label: distanceAccuracyDescription.Unknown },
        { value: 1, label: distanceAccuracyDescription.ZipToZipCrowFlies },
        { value: 2, label: distanceAccuracyDescription.ZipToZipDrivingDirections },
        { value: 3, label: distanceAccuracyDescription.ZipToAddressCrowFlies },
        { value: 4, label: distanceAccuracyDescription.ZipToAddressDrivingDirections },
        { value: 5, label: distanceAccuracyDescription.AddressToAddressCrowFlies },
        { value: 6, label: distanceAccuracyDescription.AddressToAddressDrivingDirections },
    ] as ReadonlyArray<{label: string, value: number}>
};
